import { render } from "./ProfessionItem.vue?vue&type=template&id=5547f05e"
import script from "./ProfessionItem.vue?vue&type=script&lang=js"
export * from "./ProfessionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__